import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from '~/redux/connect';
import {getAppPage, isAuthenticated} from "~/stateGetter";
import {pushWithAbsoluteLinks} from "~/actions/navigation_actions";

//import get from 'lodash/get';
//import classNames from 'classnames';
//import css from './css.css';
import pages, {guestRoutes} from '~/ui/Pages/pages';
import get from 'lodash/get';
import identify from "~/identify";
// import ModelPage from '~/ui/Pages/ModelPage/ModelPage';
// import ConnectedUpdateTestContainer from "~/ui/ModelDataManager/TestContainer";
// import ModelTreeDataManager from "~/ui/ModelDataManager/ModelTreeDataManager";


export class PageContainer extends Component {
    static propTypes = {};

    componentDidMount() {
        if (this.props.isAuthenticated && this.props.isGuestRoute) {
            this.props.navigateToRoot();
        }
    }
    
    render() {
        let Page = get(pages, this.props.appPage, pages[identify.APP_PAGE_NOTFOUND]);
        return <Page />;
    }
}

const RXPageContainer = connect(
    (state) => {
        return {
            isAuthenticated: isAuthenticated(state),
            appPage: getAppPage(state),
            isGuestRoute: !!guestRoutes[getAppPage(state)],
        }
    },
    (dispatch) => ({
        navigateToRoot: () => {
            dispatch(pushWithAbsoluteLinks("/"));
        },
    }),
    (state, dispatchers, props) => {
        if(!state.isAuthenticated && !guestRoutes[state.appPage]) {
            return { ...state, isGuestRoute: true, appPage: 'auth', ...dispatchers }
        }

        return {...state, ...dispatchers};
    }
)(PageContainer);

export default RXPageContainer;